import { baseApi } from '../../../core/baseApi';
import { 
  createGetByIdQuery,
  createUpdateMutation
} from '../../../patterns/crud';

// CRITICAL: Changed to organizationsSettingsApi (plural)
export const organizationsSettingsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationSettings: createGetByIdQuery('settings', 'Settings')(builder),
    updateOrganizationSettings: createUpdateMutation('settings', 'Settings')(builder),
  }),
  overrideExisting: true,
});

export const {
  useGetOrganizationSettingsQuery,
  useUpdateOrganizationSettingsMutation,
} = organizationsSettingsApi;